import React from "react";
import styled from "styled-components";

const StyledIconWrapper = styled.div`
  cursor: pointer;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: 1px solid #5F6368;
  background-color: ${({ active }) => {
    if (active) {
      return "#005AA9";
    }

    return "#FFFFFF";
  }};
  color: ${({ active, completed }) => {
    if (active) {
      return "#FFFFFF";
    }
    if (completed) {
      return "#0F9AD6";
    }

    return "#C4C4C4";
  }};
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translateY(-20%);
`;

const StyledIcon = ({ icons, idx, activeStep }) => (
  <StyledIconWrapper active={activeStep === idx} completed={activeStep > idx}>
    {icons[idx]}
  </StyledIconWrapper>
);

export default StyledIcon;
